import useModelProviders from "ai-management/hooks/useModelProviders";
import useModelsQuery from "ai-management/hooks/useModelsQuery";
const disabledProviderHintFor = (providerConfig, configuredDefault, defaultProviderName) => {
  if (!providerConfig || providerConfig.enabled || providerConfig.is_default) {
    return void 0;
  }
  return (configuredDefault == null ? void 0 : configuredDefault.enabled) ? `This provider is disabled, so the feature uses the default provider (${defaultProviderName}) instead.` : "This provider is disabled and the default provider is not usable, so the feature cannot run.";
};
const useProviderModelOptions = (providers, providerId) => {
  var _a, _b, _c;
  const { data: providerTypes, isLoading: providersLoading } = useModelProviders();
  const configuredDefault = providers.find(({ is_default }) => is_default);
  const providerConfig = providers.find(({ provider }) => provider === providerId);
  const { data: models, isFetching: modelsLoading } = useModelsQuery(providerId != null ? providerId : "", "stored");
  const providerNames = Object.fromEntries(providerTypes.map(({ id, display }) => [id, display]));
  const providerOptions = providers.map(({ provider, enabled }) => {
    var _a2;
    return {
      value: provider,
      label: (_a2 = providerNames[provider]) != null ? _a2 : provider,
      disabled: !enabled
    };
  });
  const defaultModelId = providerConfig == null ? void 0 : providerConfig.default_model_id;
  const defaultModelName = (_b = (_a = models.find(({ id }) => id === defaultModelId)) == null ? void 0 : _a.name) != null ? _b : defaultModelId;
  const modelOptions = models.map(({ id, name }) => ({ value: id, label: name }));
  const defaultProviderName = configuredDefault && ((_c = providerNames[configuredDefault.provider]) != null ? _c : configuredDefault.provider);
  const providerPlaceholder = configuredDefault ? `Default (${defaultProviderName})` : "No provider configured";
  let modelPlaceholder = "Select a provider first";
  if (providerId) {
    modelPlaceholder = defaultModelName ? `Default (${defaultModelName})` : "No models available";
  }
  return {
    providerOptions,
    modelOptions,
    providerPlaceholder,
    modelPlaceholder,
    providersLoading,
    modelsLoading,
    disabledProviderHint: disabledProviderHintFor(providerConfig, configuredDefault, defaultProviderName)
  };
};
export default useProviderModelOptions;
